import Vue from "vue";
import store from "./store"
import VueSweetalert2 from 'vue-sweetalert2';
import VueTippy, {TippyComponent} from "vue-tippy";
import VueRouter from "vue-router";
import CKEditor from 'ckeditor4-vue';
import Select2 from 'v-select2-component';

import customerMappingsPreviewTable from "./import/customer_mappings/CustomerMappingsPreviewTable"
import dsgvoDocumentationDetail from "./customers/components/DsgvoDocumentationDetail"
import SwitchBetweenColumnsButton from "./import/customer_mappings/components/SwitchBetweenColumnsButton";
import Pagination from "./common/pagination/Pagination";
import CustomerMappingsSubmitButton from "./import/customer_mappings/components/CustomerMappingsSubmitButton";
import LogViewer from "./logviewer/LogViewer";
import CampaignPresetManager from "./campaign_preset_manager/CampaignPresetManager";
import FmuFilterOptionsBox from "./fmu/categories/FmuFilterOptionsBox";
import FmuMediaTypes from "./fmu/media_types/FmuMediaTypes";
import TwoFactorAuth from "./TwoFactorAuth/TwoFactorAuth";
import NewsHubForm from "./news_hub/NewsHubForm";
import AdvertisementForm from "./advertisements/AdvertisementForm.vue"
import IconPicker from "./common/icon-picker/IconPicker.vue"
import AppTabConfigForm from "./app_tab_configs/AppTabConfigForm.vue"
import FmuHighlights from "./fmu/highlights/FmuHighlights";
import FmuCourses from "./fmu/courses/FmuCourses";
import BmFilterReorder from "./fmu/filter/BmFilterReorder";
import BmTopicWorlds from "./fmu/topic_worlds/BmTopicWorlds";
import BmTopicWorldsOverview from "./fmu/topic_worlds/BmTopicWorldsOverview";
import KapaMonitoringSettings from "./kapa_monitoring/KapaMonitoringSettings";
import WhatsappTemplatesForm from "./whatsapp_marketing/WhatsappTemplatesForm.vue";
import WhatsappNewsletterForm from "./whatsapp_marketing/WhatsappNewsletterForm.vue";
import Spinner from "./common/spinner/Spinner.vue";
import LoyaltyPointTransactionsTable from "./loyalty/account/LoyaltyPointTransactionsTable.vue";
import LoyaltyLevelFoldablePanel from "./loyalty/level/LoyaltyLevelFoldablePanel.vue";
import LoyaltyLevelOverviewMobilePreview from "./loyalty/level_configuration/LoyaltyLevelOverviewMobilePreview.vue";
import LoyaltyPromotionForm from "./loyalty/promotion/LoyaltyPromotionForm.vue";
import LoyaltyPointOverviewMobilePreview from "./loyalty/LoyaltyPointOverviewMobilePreview.vue";
import LoyaltyPointHistoryMobilePreview from "./loyalty/LoyaltyPointHistoryMobilePreview.vue";
import LoyaltySettingAdjustments from "./loyalty/setting/LoyaltySettingAdjustments.vue";
import LoyaltySettingExclusionsProduct from "./loyalty/setting/LoyaltySettingExclusionsProduct.vue";
import LoyaltySettingExclusionsCustomer from "./loyalty/setting/LoyaltySettingExclusionsCustomer.vue";
import LoyaltySettingExclusionsDiscount from "./loyalty/setting/LoyaltySettingExclusionsDiscount.vue";
import SimulationVariantEditor from "./loyalty/simulation/SimulationVariantEditor.vue";
import SimulationExclusionsProduct from "./loyalty/simulation/SimulationExclusionsProduct.vue";
import SimulationExclusionsCustomer from "./loyalty/simulation/SimulationExclusionsCustomer.vue";
import SimulationStatusLevels from "./loyalty/simulation/SimulationStatusLevels.vue";
import ClientAppSelector from "./app_automation/ClientAppSelector.vue";
import MassUpdate from "./app_automation/MassUpdate.vue";
import LoyaltyPointScanListViewMobilePreview from "./loyalty/point_scan/LoyaltyPointScanListViewMobilePreview.vue";
import LoyaltyPointScanDetailViewMobilePreview from "./loyalty/point_scan/LoyaltyPointScanDetailViewMobilePreview.vue";
import LoyaltyPointScanDetailViewTagChips from "./loyalty/point_scan/LoyaltyPointScanDetailViewTagChips.vue";
import RepositoryBranchSelector from "./app_automation/RepositoryBranchSelector.vue";
import AppTranslationForm from "./app_translation/AppTranslationForm.vue";
import AuditHistoryComponent from "./components/AuditHistoryComponent";
import MonitoringGroupManager from "./monitoring/define_groups/MonitoringGroupManager.vue";
import MonitoringGroupOverview from "./monitoring/define_groups/MonitoringGroupOverview.vue";
import RewardGridDetailConfig from "./v3_campaigns/reward_grid/RewardGridDetailConfig.vue";
import vSelect from "vue-select";
import 'vue-select/dist/vue-select.css';
import {Quill, VueEditor} from "vue2-editor";
import Mention from 'quill-mention-vue2-editor'
import ToggleButton from 'vue-js-toggle-button'
import $ from 'jquery';
import flatpickr from 'flatpickr';
import flatpickrDE from 'flatpickr/dist/l10n/de.js';
// Initialize vue i18n and load generated locale data
import VueInternationalization from 'vue-i18n';
import Locale from 'vue-i18n-locales.generated';
import {ClickOutside} from "./directives/click-outside";

// click outside directive
// Usage:
//     <div v-click-outside="nameOfCustomEventToCall">
//         Some content
//     </div>
Vue.directive('click-outside', ClickOutside)

window._ = require('lodash');

Vue.use(ToggleButton)
Vue.use(CKEditor);

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.$ = $;

// Project specific import
require('bootstrap-sass');
require('icheck');
require('uuidv4');


// Motor backend
window.toastr = require('toastr');
require('select2');
require('mediaelement');
require('@fancyapps/fancybox');
require('jstree');
window.tagify = require('@yaireo/tagify');
window.uuid = require('uuid');
window.switchery = require('switchery');
window.moment = require('moment');
require('clockpicker/dist/bootstrap-clockpicker.min')

window.Vue = require('vue').default;
require('vue-resource');
window.draggable = require('vuedraggable');

window.axios = require('axios');

/**
 * We'll register a HTTP interceptor to attach the "CSRF" header to each of
 * the outgoing requests issued by this application. The CSRF middleware
 * included with Laravel will automatically verify the header's value.
 */

Vue.http.interceptors.push((request, next) => {
    request.headers['X-CSRF-TOKEN'] = Laravel.csrfToken;
    next();
});

// Project specific imports
require('./inspinia/inspinia.js');
require('metismenu/dist/metisMenu');
require('jquery-slimscroll/jquery.slimscroll.js');
require('jquery-ui/ui/widgets/dialog');
var sortable = require('jquery-ui/ui/widgets/sortable');
require('eonasdan-bootstrap-datetimepicker');

window.flatpickr = flatpickr;
window.flatpickr.localize(flatpickrDE);
require('flatpickr/dist/flatpickr.css');

//require chat
// -> should go to scss?
require('jquery-ui/themes/base/core.css');
require('jquery-ui/themes/base/sortable.css');
require('jquery-ui/themes/base/theme.css');

// Initialize global event hub
Vue.prototype.$eventHub = new Vue();

Vue.use(VueInternationalization);
Vue.use(VueSweetalert2);
Vue.use(VueTippy);
Vue.component("tippy", TippyComponent);
Vue.component('Select2', Select2);
Vue.use(VueRouter);
Vue.component('v-select', vSelect);
Vue.component('VueEditor', VueEditor);

// Get curent language
//const lang = document.documentElement.lang.substr(0, 2);
// FIXME
const lang = 'de';

const i18n = new VueInternationalization({
    locale: lang,
    messages: Locale
});

const router = new VueRouter({
    mode: "history",
    routes: [],
});

require('chat/main.js');

new Vue({
    components: {
        AuditHistoryComponent,
        VueEditor,
        FmuMediaTypes,
        customerMappingsPreviewTable,
        dsgvoDocumentationDetail,
        SwitchBetweenColumnsButton,
        Pagination,
        CustomerMappingsSubmitButton,
        LogViewer,
        CampaignPresetManager,
        FmuFilterOptionsBox,
        TwoFactorAuth,
        NewsHubForm,
        AdvertisementForm,
        IconPicker,
        AppTabConfigForm,
        AppTranslationForm,
        FmuHighlights,
        FmuCourses,
        BmFilterReorder,
        BmTopicWorlds,
        BmTopicWorldsOverview,
        KapaMonitoringSettings,
        WhatsappNewsletterForm,
        WhatsappTemplatesForm,
        Spinner,
        VueRouter,
        LoyaltyPointTransactionsTable,
        LoyaltyLevelFoldablePanel,
        LoyaltyPromotionForm,
        LoyaltyLevelOverviewMobilePreview,
        LoyaltyPointOverviewMobilePreview,
        LoyaltyPointHistoryMobilePreview,
        LoyaltySettingAdjustments,
        LoyaltySettingExclusionsProduct,
        LoyaltySettingExclusionsCustomer,
        LoyaltySettingExclusionsDiscount,
        SimulationVariantEditor,
        SimulationExclusionsProduct,
        SimulationExclusionsCustomer,
        SimulationStatusLevels,
        ClientAppSelector,
        MassUpdate,
        LoyaltyPointScanListViewMobilePreview,
        LoyaltyPointScanDetailViewMobilePreview,
        LoyaltyPointScanDetailViewTagChips,
        RepositoryBranchSelector,
        Mention,
        Quill,
        MonitoringGroupManager,
        MonitoringGroupOverview,
    },
    el: '#wrapper',
    i18n,
    store,
    router,
});

// The v3-campaign form is wrapped in v-pre (so Blade's {{ }} output isn't parsed as
// Vue interpolation), so components inside it need their own root mounted directly
// on their container instead of relying on the #wrapper instance above.
if (document.getElementById('reward-grid-app')) {
    new Vue({
        el: '#reward-grid-app',
        components: {RewardGridDetailConfig},
    });
}
